import { AuthApiService } from '@revenuewell/logic-http';
import { NavigationService } from '@revenuewell/logic-navigation';
import { OidcService } from '@revenuewell/logic-oidc';
import { CareCreditIHSTokens, CareCreditPatientPrescreenInfo } from '../../types/payment/care-credit';
import { PaymentProcessorType } from '../../types/payment/payment-processor-type';

export default class PaymentService extends AuthApiService {
  private config: any;

  constructor(config: any, oidcService: OidcService) {
    super(oidcService, new NavigationService());
    this.config = config;
  }

  getCareCreditPatientPrescreenInfo = async (
    locationId: number,
    patientId?: number
  ): Promise<CareCreditPatientPrescreenInfo> => {
    const url = `${await this.config.payment.apiUrl}/locations/${locationId}/care-credit?patientId=${patientId}`;
    const response = await this.authFetch(url, { method: 'GET' });
    const result = await response.json();

    return result as CareCreditPatientPrescreenInfo;
  };

  getCareCreditPreApprovalIHSTokens = async (patientId: number): Promise<CareCreditIHSTokens> => {
    const url = `${await this.config.payment.apiUrl}/carecredit/preapprovalihstokens/${patientId}`;
    const response = await this.authFetch(url, { method: 'GET' });
    const result = await response.json();

    return result as CareCreditIHSTokens;
  };

  getCareCreditSubmitPaymentTokens = async (patientId: number): Promise<CareCreditIHSTokens> => {
    const url = `${await this.config.payment.apiUrl}/carecredit/paymentihstokens/${patientId}`;
    const response = await this.authFetch(url, { method: 'GET' });
    const result = await response.json();

    return result as CareCreditIHSTokens;
  };

  getCareCreditRefundPaymentTokens = async (patientId: number): Promise<CareCreditIHSTokens> => {
    const url = `${await this.config.payment.apiUrl}/carecredit/refundihstokens/${patientId}`;
    const response = await this.authFetch(url, { method: 'GET' });
    const result = await response.json();

    return result as CareCreditIHSTokens;
  };

  getPaymentProcessorType = async (locationId: number): Promise<PaymentProcessorType> => {
    const url = `${await this.config.payment.apiUrl}/locations/${locationId}/payment-processor-type`;
    const response = await this.authFetch(url, { method: 'GET' });
    const result = await response.json();

    return result as PaymentProcessorType;
  };
}
